import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import EmberButton from "@/components/EmberButton";
import BrandLogo from "@/components/BrandLogo";
import { toast } from "sonner";

export default function AdminLoginPage() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await adminLogin(username, password);
            localStorage.setItem("smokin_admin_token", res.access_token);
            toast.success("Welcome back, Mo.");
            navigate("/admin", { replace: true });
        } catch (err) {
            const msg = err?.response?.data?.detail || "Login failed";
            toast.error(typeof msg === "string" ? msg : "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4" data-testid="admin-login-page">
            <Card className="surface-card border-0 w-full max-w-md">
                <CardContent className="p-8">
                    <div className="flex items-center gap-3 logo-glow mb-6">
                        <BrandLogo size={48} />
                        <div>
                            <div className="font-display text-xl tracking-[0.06em]">SMOKIN&rsquo; MO&rsquo;S</div>
                            <div className="text-[10px] uppercase tracking-[0.32em] text-orange-300/90">Admin Sign-in</div>
                        </div>
                    </div>
                    <form className="space-y-4" onSubmit={submit} data-testid="admin-login-form">
                        <div>
                            <Label htmlFor="username" className="text-white/80">Username</Label>
                            <Input id="username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="mo" autoFocus className="mt-1 bg-black/40 border-white/10" data-testid="admin-login-username" />
                        </div>
                        <div>
                            <Label htmlFor="password" className="text-white/80">Password</Label>
                            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-1 bg-black/40 border-white/10" data-testid="admin-login-password" />
                        </div>
                        <div className="pt-2">
                            <EmberButton asChild>
                                <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full text-center">
                                    {loading ? "Signing in..." : "Sign in"}
                                </button>
                            </EmberButton>
                        </div>
                    </form>
                    <div className="mt-6 text-xs text-white/50 leading-relaxed">
                        Default credentials for setup: <span className="text-white">mo</span> / <span className="text-white">smokinmos2026</span>. Change them in the backend env (<code>ADMIN_PASSWORD_HASH</code>) before going live.
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
